export const PHONE_BRANDS_LOAD = 'PHONE_BRANDS_LOAD';
export const PHONE_BRANDS_LOADED = 'PHONE_BRANDS_LOADED';
export const PHONES_LOAD = 'PHONES_LOAD';
export const PHONES_UNLOAD = 'PHONES_UNLOAD';
export const PHONES_LOADED = 'PHONES_LOADED';
